import { c as _c } from "react/compiler-runtime";
import NextImage, { ImageProps as NextImageProps } from 'next/image';
export type ImageProps = NextImageProps;
export const Image: React.FC<ImageProps> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <NextImage {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};